const GRAY_BG_CLASS = "fts-bg-gray";

export const removeGrayBody = () => {
    document.body.classList.remove(GRAY_BG_CLASS);
}

export const setGrayBody = () => {
    document.body.classList.add(GRAY_BG_CLASS);
}